import axios from 'axios';
import {downloadFile} from "../../../utils/file/download";

export class LogService {
    getLog(first, rows, filters) {
        return axios.get('/appapv/getLog.action', {
            params: {
                start: first,
                limit: rows,
                fechaInicial: filters.startDate ?
                    filters.startDate.getFullYear() + "-" +
                    (filters.startDate.getMonth() + 1) + "-" +
                    filters.startDate.getDate() : "",
                fechaFinal: filters.finalDate ?
                    filters.finalDate.getFullYear() + "-" +
                    (filters.finalDate.getMonth() + 1) + "-" +
                    filters.finalDate.getDate() : "",
                usuario: filters.catUserFilter.descripcionId ?
                    filters.catUserFilter.descripcionId : "TODOS",
            }
        }).then(res => res.data);
    }

    exportLog(option, filters) {
        let params = {
            fechaInicial: filters.startDate ?
                filters.startDate.getFullYear() + "-" +
                (filters.startDate.getMonth() + 1) + "-" +
                filters.startDate.getDate() : "",
            fechaFinal: filters.finalDate ?
                filters.finalDate.getFullYear() + "-" +
                (filters.finalDate.getMonth() + 1) + "-" +
                filters.finalDate.getDate() : "",
            usuario: filters.catUserFilter.descripcionId ?
                filters.catUserFilter.descripcionId : "TODOS",
        };

        let url = option === 'XLS' ? '/appapv/getLogXls.action' : '/appapv/getLogPdf.action';

        return downloadFile(
            url,
            params
        );
    }
}